import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import HourglassEmptyOutlinedIcon from "@mui/icons-material/HourglassEmptyOutlined";
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";

// TODO: remove once GET /invoicing-service/api/v1/wayaquick/admin/invoices is live —
// this mirrors the shape of the merchant-facing invoice-filter response, plus a
// merchantName so a cross-merchant admin list is possible.
export const MOCK_INVOICES = [
  {
    id: 1,
    invoiceNumber: "LWGAFS",
    merchantName: "chris-neo ventures ltd",
    merchantId: "MER_LuUGL781016931056hb5GQ",
    buyerName: "Okonji Nicholas",
    buyerEmailAddress: "admin@gmail.com",
    buyerPhoneNumber: "09025697028",
    invoiceDate: "2026-07-06T23:00:00.000Z",
    paymentDueDate: "2026-07-07T23:00:00.000Z",
    sumTotalBeforeVAT: "5000.00",
    vatAmount: "7.5%",
    totalAmount: "5375.00",
    invoiceStatus: "UNSETTLED",
    bankName: "WAYA MICROFINANCE BANK",
    accountNumber: "9420637475",
    itemsList: [{ quantity: 1, unitPrice: 5000.0, description: "Item 1 - iPhone 17" }],
  },
  {
    id: 2,
    invoiceNumber: "TI34TB",
    merchantName: "chris-neo ventures ltd",
    merchantId: "MER_LuUGL781016931056hb5GQ",
    buyerName: "great Victor",
    buyerEmailAddress: "neo88great@gmail.com",
    buyerPhoneNumber: "2349025697028",
    invoiceDate: "2026-06-24T08:24:00.000Z",
    paymentDueDate: "2026-07-01T00:00:00.000Z",
    sumTotalBeforeVAT: "12800.00",
    vatAmount: "7.5%",
    totalAmount: "13760.00",
    invoiceStatus: "UNSETTLED",
    bankName: "WAYA MICROFINANCE BANK",
    accountNumber: "9317449060",
    itemsList: [
      { quantity: 1, unitPrice: 10400.0, description: "techno phone" },
      { quantity: 1, unitPrice: 2400.0, description: "towel" },
    ],
  },
  {
    id: 3,
    invoiceNumber: "438L24",
    merchantName: "chris-neo ventures ltd",
    merchantId: "MER_LuUGL781016931056hb5GQ",
    buyerName: "Okonji Nicholas",
    buyerEmailAddress: "admin@gmail.com",
    buyerPhoneNumber: "09025697028",
    invoiceDate: "2026-06-19T19:17:00.000Z",
    paymentDueDate: "2026-06-25T00:00:00.000Z",
    sumTotalBeforeVAT: "850000.00",
    vatAmount: "7.5%",
    totalAmount: "913750.00",
    invoiceStatus: "UNSETTLED",
    bankName: "WAYA MICROFINANCE BANK",
    accountNumber: "9420637475",
    itemsList: [{ quantity: 1, unitPrice: 850000.0, description: "iphone 17" }],
  },
  {
    id: 4,
    invoiceNumber: "BXQXXH",
    merchantName: "chris-neo ventures ltd",
    merchantId: "MER_LuUGL781016931056hb5GQ",
    buyerName: "great Victor",
    buyerEmailAddress: "neo88great@gmail.com",
    buyerPhoneNumber: "+2349025697028",
    invoiceDate: "2026-06-18T14:15:00.000Z",
    paymentDueDate: "2026-06-25T00:00:00.000Z",
    sumTotalBeforeVAT: "5600.00",
    vatAmount: "7.5%",
    totalAmount: "6020.00",
    invoiceStatus: "UNSETTLED",
    bankName: "WAYA MICROFINANCE BANK",
    accountNumber: "9420637475",
    itemsList: [{ quantity: 1, unitPrice: 5600.0, description: "indomie" }],
  },
  {
    id: 5,
    invoiceNumber: "Z4UPHZ",
    merchantName: "chris-neo ventures ltd",
    merchantId: "MER_LuUGL781016931056hb5GQ",
    buyerName: "great Victor",
    buyerEmailAddress: "neo88great@gmail.com",
    buyerPhoneNumber: "+2349025697028",
    invoiceDate: "2026-06-17T08:15:00.000Z",
    paymentDueDate: "2026-06-24T00:00:00.000Z",
    sumTotalBeforeVAT: "2000.00",
    vatAmount: "7.5%",
    totalAmount: "2150.00",
    invoiceStatus: "UNSETTLED",
    bankName: "WAYA MICROFINANCE BANK",
    accountNumber: "9420637475",
    itemsList: [{ quantity: 1, unitPrice: 2000.0, description: "techno phone" }],
  },
  {
    id: 6,
    invoiceNumber: "IFKRL1",
    merchantName: "Test 4 Merchant",
    merchantId: "MER_QA1425590086others",
    buyerName: "Sobechukwu Chinagorom",
    buyerEmailAddress: "bgrok@gmail.com",
    buyerPhoneNumber: "+2348067880556",
    invoiceDate: "2026-06-13T23:00:00.000Z",
    paymentDueDate: "2026-06-27T23:00:00.000Z",
    sumTotalBeforeVAT: "1000.00",
    vatAmount: "7.5%",
    totalAmount: "1075.00",
    invoiceStatus: "SETTLED",
    bankName: "WAYA MICROFINANCE BANK",
    accountNumber: "9420637475",
    itemsList: [{ quantity: 1, unitPrice: 1000.0, description: "Test Item" }],
  },
  {
    id: 7,
    invoiceNumber: "MJP496",
    merchantName: "Test 3 Merchant",
    merchantId: "MER_QA1425477447others",
    buyerName: "Sijibomi Aderinlewo",
    buyerEmailAddress: "aderinlewomoses@gmail.com",
    buyerPhoneNumber: "+2348165730565",
    invoiceDate: "2026-06-13T23:00:00.000Z",
    paymentDueDate: "2026-06-20T23:00:00.000Z",
    sumTotalBeforeVAT: "300.00",
    vatAmount: "7.5%",
    totalAmount: "322.50",
    invoiceStatus: "UNSETTLED",
    bankName: "WAYA MICROFINANCE BANK",
    accountNumber: "9420637475",
    itemsList: [{ quantity: 1, unitPrice: 300.0, description: "Test Item" }],
  },
  {
    id: 8,
    invoiceNumber: "951TR9",
    merchantName: "Cheese Merchant",
    merchantId: "MER_QA1423473062others",
    buyerName: "Sijibomi Aderinlewo",
    buyerEmailAddress: "aderinlewomoses@gmail.com",
    buyerPhoneNumber: "+2348165730565",
    invoiceDate: "2026-06-13T23:00:00.000Z",
    paymentDueDate: "2026-06-21T23:00:00.000Z",
    sumTotalBeforeVAT: "20000.00",
    vatAmount: "7.5%",
    totalAmount: "21500.00",
    invoiceStatus: "UNSETTLED",
    bankName: "",
    accountNumber: "",
    itemsList: [{ quantity: 1, unitPrice: 20000.0, description: "Fries" }],
  },
  {
    id: 9,
    invoiceNumber: "3YI6BJ",
    merchantName: "Excellence Merchant",
    merchantId: "MER_QA1422930777others",
    buyerName: "great Victor",
    buyerEmailAddress: "neo88great@gmail.com",
    buyerPhoneNumber: "+2349025697028",
    invoiceDate: "2026-06-13T23:00:00.000Z",
    paymentDueDate: "2026-06-22T23:00:00.000Z",
    sumTotalBeforeVAT: "4800.00",
    vatAmount: "7.5%",
    totalAmount: "5160.00",
    invoiceStatus: "UNSETTLED",
    bankName: "",
    accountNumber: "",
    itemsList: [
      { quantity: 4, unitPrice: 1000.0, description: "Black Excellence" },
      { quantity: 2, unitPrice: 400.0, description: "Black Tees" },
    ],
  },
  {
    id: 10,
    invoiceNumber: "Z4CL3E",
    merchantName: "Excellence Merchant",
    merchantId: "MER_QA1422930777others",
    buyerName: "Unknown Buyer",
    buyerEmailAddress: "",
    buyerPhoneNumber: null,
    invoiceDate: "2026-06-15T23:00:00.000Z",
    paymentDueDate: "2026-06-23T23:00:00.000Z",
    sumTotalBeforeVAT: "4000.00",
    vatAmount: "7.5%",
    totalAmount: "4300.00",
    invoiceStatus: "UNSETTLED",
    bankName: "",
    accountNumber: "",
    itemsList: [{ quantity: 4, unitPrice: 1000.0, description: "excellent buy" }],
  },
];

export const InvoicesSummary = [
  {
    title: "Total Invoices",
    objKeyRepr: "totalInvoices",
    icon: <ReceiptLongOutlinedIcon fontSize="small" />,
  },
  {
    title: "Settled",
    objKeyRepr: "totalSettled",
    icon: <CheckCircleOutlineIcon fontSize="small" color="success" />,
  },
  {
    title: "Unsettled",
    objKeyRepr: "totalUnsettled",
    icon: <HourglassEmptyOutlinedIcon fontSize="small" color="warning" />,
  },
  {
    title: "Total Value",
    objKeyRepr: "totalValue",
    icon: <PaymentsOutlinedIcon fontSize="small" color="primary" />,
  },
];
